import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { CreatePlanSubjectType, DeletePlanSubjectType, PlanSubjectType, UpdatePlanSubjectType } from "../../types/PlanSubject";
import { get, patch, post, put } from "../../utils/axios-config";
import { PLAN_SUBJECT } from "../../utils/constants";

export const createPlanSubject = async (data: CreatePlanSubjectType) => await post<CreatePlanSubjectType, string>(PLAN_SUBJECT, data);
export const updatePlanSubject = async (data: UpdatePlanSubjectType) => await put<UpdatePlanSubjectType, string>(PLAN_SUBJECT, data);
export const deletePlanSubject = async (data: DeletePlanSubjectType) => await patch<DeletePlanSubjectType, boolean>(PLAN_SUBJECT, data);

export const getPlanSubjects = async (data?: PagedRequestType) => {

    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });

    if (data?.IdCourse) {
        queryParams.append('IdCourse', data.IdCourse);
    }
    if (data?.IdPlan) {
        queryParams.append('IdPlan', data.IdPlan);
    }

    if (data?.IdSubject) {
        queryParams.append('IdSubject', data.IdSubject);
    }

    if (data?.Semester) {
        queryParams.append('Semester', data.Semester.toString());
    }

    if (data?.IsCore) {
        queryParams.append('IsCore', data.IsCore.toString());
    }

    if (data?.HasExam) {
        queryParams.append('HasExam', data.HasExam.toString());
    }

    if (data?.Level) {
        queryParams.append('Level', data.Level.toString());
    }

    if (data?.Credits) {
        queryParams.append('Credits', data.Credits.toString());
    }

    const url = `${PLAN_SUBJECT}?${queryParams.toString()}`;
    return await get<PagedResultsType<PlanSubjectType>>(url);
};